module.exports = __webpack_public_path__ + "img/trip_sendai25.44a0ff62.jpg";